<template>
  <div>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat(true)"
      class="navbarBtnTashxis mr-2"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать
    </b-button>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat(false)"
      class="navbarBtnTashxis"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать Операция олди эпикризи
    </b-button>
    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2 mr-2 ml-2"
      v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
      @click="getShablonDoctor('klinik_tash', { type: false })"
    >
      <b-icon icon="arrow-down-circle-fill"></b-icon>
    </b-button>

    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2"
      @click="(status = 'klinik_tash'), (row_click_type = { type: false })"
      v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
    >
      <b-icon icon="arrow-up-circle-fill"></b-icon>
    </b-button>
    <b-modal
      :id="'modal-shablon' + 'klinik_tash' + modalIdCom"
      size="lg"
      :title="$t('Шаблонлар рўйхати')"
      hide-footer
    >
      <Shablon
        :modalIdCom="modalIdCom"
        :plus_dont_show="true"
        :shabType="'klinik_tash'"
        :itemsShablon="itemsShablon"
        @ShablonGet="getShablon"
        @RowClickedShab="RowClickedShab"
      />
    </b-modal>
    <b-modal
      :id="'modal-new-shab-creat-klinik_tash' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      hide-footer
    >
      <div>
        <div>
          <b-input type="text" v-model="name"></b-input>
        </div>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="ShifokorShablonClose"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="ShifokorShablon"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div style="display: flex; justify-content: space-between;">
      <div class="stat-bemor-text">
        <div>
          <input
            v-model="selectShablonJson.value1"
            class="input-stile"
            type="date"
            @input="textChange"
          />
          <label>OQTOSH</label>
          <input
            v-model="selectShablonJson.value18"
            class="input-stile"
            style="width: 150px;"
            type="text"
            @input="textChange"
          />
          <label> bo'lim boshlig'i va davolovchi shifokor</label>
          <input
            v-model="selectShablonJson.value2"
            class="input-stile"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value2', 'klinik_tash_value2')"
            @input="textChange"
          />
          <label>ko'ruvi va klinika tashxisni asoslash</label>
        </div>
        <div>
          <label>Kelgandagi shikoyatlari:</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
            @click="
              getShablonDoctor('karta_value1', { type: true, value: 'value3' })
            "
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>

          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="
              (status = 'karta_value1'),
                (row_click_type = { type: true, value: 'value3' })
            "
            v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            v-model="selectShablonJson.value3"
            @input="textChange($event)"
            rows="6"
            style="width: 100%;"
          ></textarea>
        </div>
        <div>
          <label>Anamnezidan:</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
            @click="
              getShablonDoctor('kas_tar_value10', {
                type: true,
                value: 'value10'
              })
            "
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>

          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="
              (status = 'kas_tar_value10'),
                (row_click_type = { type: true, value: 'value10' })
            "
            v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            v-model="selectShablonJson.value10"
            @input="textChange($event)"
            rows="6"
            style="width: 100%;"
          ></textarea>
        </div>
        <div>
          <label>Obyektiv:</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
            @click="
              getShablonDoctor('kas_tar_value11', {
                type: true,
                value: 'value11'
              })
            "
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>

          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="
              (status = 'kas_tar_value11'),
                (row_click_type = { type: true, value: 'value11' })
            "
            v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            v-model="selectShablonJson.value11"
            @input="textChange($event)"
            rows="6"
            style="width: 100%;"
          ></textarea>
        </div>
        <div v-for="(item, index) in selectShablonJson.value12" :key="index">
          <input
            v-model="item.name"
            type="text"
            @input="textChange($event)"
            class="input-stile"
            style="width: 600px;"
          />
          <textarea
            v-model="item.value"
            @input="textChange($event)"
            style="width: 100%; margin-top: 5px;"
            rows="2"
          ></textarea>
        </div>
      </div>
      <div class="stat-bemor-text">
        <label>Tor mutahasis:</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
          @click="
            getShablonDoctor('klinik_tash_value20', {
              type: true,
              value: 'value20'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'klinik_tash_value20'),
              (row_click_type = { type: true, value: 'value20' })
          "
          v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value20"
          @input="textChange($event)"
          style="width: 100%;"
          rows="3"
        ></textarea>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
          @click="
            getShablonDoctor('klinik_tash_value13', {
              type: true,
              value: 'value13'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'klinik_tash_value13'),
              (row_click_type = { type: true, value: 'value13' })
          "
          v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value13"
          @input="textChange($event)"
          style="width: 100%;"
          rows="3"
        ></textarea>

        <label
          >Bemor shikoyati, anamnezi abektiv ko'ruv labarator-instrumental
          tekshiruv natijalariga asoslanib quyidagi klinik tashxis
          qo'yildi.</label
        >
        <br />
        <div>
          <label>Asosiy:</label>
          <input
            v-model="selectShablonJson.value6"
            @input="textChange($event)"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value6', 'klinik_tash_value4')"
            class="input-stile"
            style="width: 600px;"
          />
        </div>
        <div>
          <label>Xamroh:</label>
          <input
            v-model="selectShablonJson.value7"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value7', 'klinik_tash_value5')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 600px;"
          />
        </div>
        <label>Asorati</label>
        <input
          v-model="selectShablonJson.value8"
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value8', 'klinik_tash_value6')"
          @input="textChange($event)"
          class="input-stile"
          style="width: 600px;"
        />
        <br />
        <label>Tavsiyalar</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'klinik_tash' + modalIdCom"
          @click="
            getShablonDoctor('klinik_tash_value15', {
              type: true,
              value: 'value15'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'klinik_tash_value15'),
              (row_click_type = { type: true, value: 'value15' })
          "
          v-b-modal="'modal-new-shab-creat-klinik_tash' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value15"
          @input="textChange($event)"
          style="width: 100%;"
          rows="3"
        ></textarea>
        <div class="display-flex">
          <label>Davolovchi shifokor:</label>
          <input
            v-model="selectShablonJson.value17"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value17', 'kas_tash_koch_value17')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 300px;"
          />
        </div>
        <div class="display-flex">
          <label>Bo'lim boshlig'i:</label>
          <input
            v-model="selectShablonJson.value19"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value19', 'kas_tash_koch_value19')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 300px;"
          />
        </div>
      </div>
    </div>
    <b-modal
      :id="'shablon-select' + 'select' + modalIdCom"
      size="xl"
      hide-footer
    >
      <div style="display: flex; justify-content: space-between;">
        <button
          class="navbarBtnTashxis mb-2"
          v-b-modal="'modal-shab-select-create-klinik-tashxis' + modalIdCom"
          @click="plusClick"
        >
          <b-icon icon="plus-lg"></b-icon>
        </button>

        <b-form-group
          label-for="filterTekshiruvlar-input"
          label-cols-sm="1"
          label-align-sm="right"
          label-size="sm"
          class="mb-2 col-8"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterTekshiruvlar-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Қидирув')"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                variant="danger"
                @click="filter = ''"
              >
                {{ $t("Тозалаш") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <b-table
          id="bemor-table"
          ref="refTable"
          hover
          sort-icon-left
          striped
          primary-key="id"
          :items="itemShablon"
          :fields="fields"
          :filter="filter"
          :current-page="currentPage"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @row-clicked="RowClickedShab($event, null, true)"
          stacked="md"
          show-empty
          small
          @filtered="onFiltered"
        >
          <template #cell(№)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(actions)="row">
            <b-row class="ml-1">
              <section
                style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
              >
                <div style="display: flex;">
                  <b-button
                    v-b-modal="
                      'modal-shab-select-create-klinik-tashxis' + modalIdCom
                    "
                    variant="outline-primary"
                    @click="userLink(row.item)"
                    class="pencil"
                  >
                    <b-icon
                      style="width: 15px;"
                      variant="outline-primary"
                      icon="pencil-fill"
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>
                  <div>
                    <b-button
                      class="trash ml-2"
                      style=""
                      variant="outline-danger"
                      @click="trash(row.item.id)"
                    >
                      <b-icon
                        style="width: 15px;"
                        icon="trash-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </b-button>
                  </div>
                </div>
              </section>
            </b-row>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      :id="'modal-shab-select-create-klinik-tashxis' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      size="lg"
      hide-footer
    >
      <div>
        <b-input
          type="text"
          style="border: 1px solid #ccc; border-radius: 5px;"
          v-model="datas.name"
        >
        </b-input>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="Close()"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="Shablon()"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      :style="{
        top: divPosition.top + 'px',
        left: divPosition.left + 'px',
        width: divPosition.width + 'px',
        display: show ? 'block' : 'none'
      }"
      class="dynamic-div-kas"
    >
      <div
        v-for="item in itemShablon"
        class="drop-down"
        @click="selectItemValue(item.name)"
      >
        {{ item.name }}
        <div class="display-flex">
          <b-button
            v-b-modal="'modal-shab-select-create-klinik-tashxis' + modalIdCom"
            variant="outline-primary"
            style="width: 30px; height: 30px"
            @click="userLink(row.item)"
            class="pencil"
          >
            <b-icon
              style="width: 10px;"
              variant="outline-primary"
              icon="pencil-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
          <b-button
            class="trash ml-2"
            style="width: 30px; height: 30px"
            variant="outline-danger"
            @click="trash(item.id)"
          >
            <b-icon
              style="width: 10px;"
              icon="trash-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
        </div>
      </div>
      <b-button
        class="insertbtn"
        style="align-items: center; text-align: center"
        variant="success"
        @click="setStatus(45)"
        v-b-modal="'modal-shab-select-create-klinik-tashxis' + modalIdCom"
      >
        <b-icon icon="plus" color="#fff"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Shablon from "../Shifokor/Shablon.vue";
export default {
  props: ["statsionar_text", "history_id", "modalIdCom"],
  components: {
    Shablon
  },
  data() {
    return {
      options: [],
      show: false,
      divPosition: {
        top: 0,
        left: 0,
        with: 0
      },
      datas: {
        id: 0,
        name: "",
        status: ""
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      itemsShablon: [],
      name: "",
      selectShablonJson: {},
      itemShablon: [],
      status: "",
      row_click_type: {
        type: false,
        value: ""
      },
      key: null,
      ValueSelect: "",
      fields: [
        "№",
        { key: "name", label: "Номи", sortable: true },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created() {
    if (this.statsionar_text == "" || !this.statsionar_text) {
      this.selectShablonJson = {
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        value9: null,
        value10: null,
        value11: null,
        value12: [],
        value13: null,
        value14: null,
        value15: null,
        value16: null,
        value17: null,
        value18: null,
        value20: null
      };
    } else {
      this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
    }
  },
  watch: {
    statsionar_text(newVal, old) {
      this.selectShablonJson = JSON.parse(newVal.toString());
    },
    "$store.state.ArrowData"(newVal, old) {
      if (newVal) {
        this.selectShablonJson.value12.push(newVal);
        this.textChange();
      }
    }
  },
  methods: {
    allPechat(type) {
      let t = {};
      t = {
        type: type,
        bemor: this.$store.state.bemor,
        value: this.statsionar_text
      };
      localStorage.setItem("klinik_tash", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-klinik-tash"
      });
      window.open(rout.href, "_blank");
    },
    selectItemValue(value) {
      if (this.selectShablonJson[`${this.row_click_type.value}`] == null) {
        this.selectShablonJson[`${this.row_click_type.value}`] = value;
      } else {
        this.selectShablonJson[`${this.row_click_type.value}`] += ` ${value}`;
      }
      setTimeout(() => {
        this.show = false;
      }, 200);
      this.textChange();
    },
    showDiv(event, key, status) {
      this.row_click_type.value = key;
      this.status = status;
      this.getShablon(status);
      const input = event.target;
      const rect = input.getBoundingClientRect();
      this.divPosition.top = rect.top + window.pageYOffset + rect.height - 365;
      this.divPosition.left = rect.left + window.pageXOffset - 20;
      // this.divPosition.top = rect.bottom + window.scrollY;
      // this.divPosition.left = rect.left + window.scrollX;
      this.divPosition.width = rect.width;
      setTimeout(() => {
        this.handleBlur("", true);
      }, 200);
    },
    handleBlur(event, type) {
      if (!type) {
        setTimeout(() => {
          this.show = false;
        }, 100);
      } else {
        this.show = true;
      }
    },
    ShifokorShablonClose() {
      this.name = "";
      this.$bvModal.hide(
        `${"modal-new-shab-creat-klinik_tash" + this.modalIdCom}`
      );
    },
    RowClickedShab($events, ind, type) {
      if (this.row_click_type.type) {
        this.selectShablonJson[`${this.row_click_type.value}`] = type
          ? $events.name
          : $events.text;
      } else {
        let text = JSON.parse($events.text.toString());
        this.selectShablonJson = text;
      }
      this.textChange();
      this.$bvModal.hide(
        `${"modal-shablon" + "klinik_tash" + this.modalIdCom}`
      );
      this.$bvModal.hide("shablon-select" + "select" + this.modalIdCom);
    },
    getShablonDoctor(key, type) {
      let self = this;
      self.status = key;
      self.row_click_type = type;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: 1,
          doc_type: key
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    ShifokorShablon() {
      let self = this;
      let text = "";
      if (self.row_click_type.type) {
        text = self.selectShablonJson[self.row_click_type.value];
      } else {
        text = JSON.stringify(self.selectShablonJson).toString();
      }
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: {
          name: self.name,
          text: text,
          doctor_id: 1,
          doc_type: self.status ? self.status : "klinik_tash"
        }
      }).then(res => {
        if (res) {
          self.$bvModal.hide(
            `${"modal-new-shab-creat-klinik_tash" + self.modalIdCom}`
          );
        }
      });
    },
    textChange($event) {
      this.$emit(
        "statsionar_text_change",
        JSON.stringify(this.selectShablonJson).toString(),
        "asoslash"
      );

      // this.filteredShablon = this.itemsShablon.filter((item) => {
      //   let ok = false;
      //   if (item.name.trim().toLowerCase().includes($event.target.value.trim().toLowerCase())) {
      //     ok = true;
      //   }
      //   return ok;
      // })
    },
    plusClick() {
      this.datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    setStatus($events) {
      if ($events.keyCode == 45 || $events == 45) {
        this.datas = {
          name: this.ValueSelect,
          status: this.status
        };
        this.$bvModal.show(
          "modal-shab-select-create-klinik-tashxis" + this.modalIdCom
        );
      }
    },
    selectKey(key) {
      this.status = key;
      this.getShablon(key);
    },
    getShablon(status) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_select/shablonOne",
        data: { status: status }
      }).then(res => {
        if (res) {
          self.itemShablon = res.data.data;
        }
      });
    },
    userLink(item) {
      this.datas = item;
      this.$bvModal.show(
        "modal-shab-select-create-klinik-tashxis" + this.modalIdCom
      );
    },
    trash(id) {
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_select/delete/" + id
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          // self.$bvModal.hide('modal-shab-select-create-klinik-tashxis' + self.index + self.modalIdCom);
        }
      });
    },
    ValueSelChange() {
      let value = JSON.stringify(this.statsionar_text);
      // console.log(this.statsionar_text, value);
      this.$emit("selectSablon", value, this.index);
      // this.shablonData = JSON.stringify(this.statsionar_text)
    },
    ValueSel(e) {
      this.ValueSelect = e;
    },
    Shablon() {
      let self = this;
      let method = "";
      let url = "";
      if (this.datas.id) {
        method = "patch";
        url = "/shablon_select/update/" + self.datas.id;
      } else {
        self.datas.status = self.status;
        method = "post";
        url = "/shablon_select/create";
      }
      axios({
        method: method,
        url: url,
        data: self.datas
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          self.$bvModal.hide(
            "modal-shab-select-create-klinik-tashxis" + self.modalIdCom
          );
          self.datas = {
            id: 0,
            name: "",
            status: ""
          };
        }
      });
    },
    Close() {
      datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}
.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.dynamic-div-kas {
  min-width: 150px;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 5;
  cursor: pointer;
  display: none;
  .drop-down {
    cursor: pointer;
    align-items: center;
    height: 35px;
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    font-size: 13pt;
  }
}
.drop-down:hover {
  background: rgb(46, 165, 255);
  color: #fff;
}

.stat-bemor-text {
  width: 49.5%;
  padding: 10px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  label {
    font-family: "Times New Roman", Times, serif;
    margin-top: 5px;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
  }
  textarea {
    font-family: "Times New Roman", Times, serif;
    font-size: 13pt;
    font-weight: 500;
  }
}
.input-stile {
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: "Times New Roman", Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.display-flex {
  display: flex;
}
.btn-select {
  background-color: #fff;
  border: none;
  // border: 1px  solid #000;
  // border-radius: 50%;
  font-size: 14pt;
  font-weight: 700;
  height: 27px;
  width: 27px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: 3px;
  right: 25px;
  color: #6c6868;
  /* left: -50px; */
}
</style>
